module.exports = __webpack_public_path__ + "img/Charts1.96e500c2.png";